import React, { Component } from 'react'

import VannmaalerItem from './vannmaalere/vannmaaler-item'
import { ButtonToolbar } from 'react-bootstrap'
import NkaButton from 'nka-button'
import NkModal from '../felles/Dialogs/NKModal.jsx'
import KartModal from '../felles/Kart/kartContainer.jsx'

import 'nka-button/dist/style.css'

export default class ArbeidslisteAktiv extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isKartModalOpen: false
        }

        this._onOpenKartModal = this._onOpenKartModal.bind(this)
        this._closeKartModal = this._closeKartModal.bind(this)
    }

    _onOpenKartModal() {
        this.setState({
            isKartModalOpen: true
        }
        )
    }

    _closeKartModal() {
        this.setState({
            isKartModalOpen: false
        })
    }

    render() {
        let vannmaalere = this.props.vannmaalere.map(maaler => <VannmaalerItem key={maaler.MaalerId} maaler={maaler} match={this.props.match} />)

        return (
            <div className="listeContainer">
                <h2>{this.props.tittel}</h2>
                <p>{this.props.beskrivelse}</p>
                <ButtonToolbar>
                    <NkaButton icon="lokasjon" onClick={this._onOpenKartModal}>
                        Vis i kart
                        </NkaButton>
                </ButtonToolbar>
                <div>
                    {vannmaalere}
                </div>

                <NkModal size='large' isOpen={this.state.isKartModalOpen}>
                    <KartModal id={this.props.id} onClose={this._closeKartModal} history={this.props.history} skalviseMaalerskfteKnapp={true}/>
                </NkModal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/utskiftning/arbeidsliste-aktiv.jsx